import { defineMessages, type MessageDescriptor } from 'react-intl';

const intlMessages = {
	loginButton: {
		id: 'twg-microsite.navbar.loginButton',
		defaultMessage: 'Log in',
		description: 'Button to log in to the application',
	},
	loginAriaLabel: {
		id: 'twg-microsite.navbar.loginAriaLabel',
		defaultMessage: 'Log in',
		description: 'Accessible label for the log in button',
	},
	userAccountMenuAriaLabel: {
		id: 'twg-microsite.navbar.userAccountMenuAriaLabel',
		defaultMessage: 'Account menu, {userName}',
		description:
			'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.',
	},
	teamworkGraphBrand: {
		id: 'twg-microsite.navbar.teamworkGraphBrand.do-not-translate',
		defaultMessage: 'Atlassian Teamwork Graph',
		description: 'Teamwork Graph brand name shown in the nav bar',
	},
	navAbout: {
		id: 'twg-microsite.navbar.navAbout',
		defaultMessage: 'About',
		description: 'Navigation link to the About section of the microsite',
	},
	navConnectors: {
		id: 'twg-microsite.navbar.navConnectors',
		defaultMessage: 'Connectors',
		description: 'Navigation link to the Connectors section of the microsite',
	},
	navCli: {
		id: 'twg-microsite.navbar.navCli.do-not-translate',
		defaultMessage: 'CLI',
		description: 'Navigation link to the CLI section of the microsite',
	},
	navMcp: {
		id: 'twg-microsite.navbar.navMcp.do-not-translate',
		defaultMessage: 'MCP',
		description:
			'Navigation link to the Getting Started section of the microsite, pre-selecting the MCP install instructions tab',
	},
	navDocs: {
		id: 'twg-microsite.navbar.navDocs',
		defaultMessage: 'Docs',
		description: 'Navigation link to the documentation section of the microsite',
	},
	navYourGraph: {
		id: 'twg-microsite.navbar.navYourGraphs',
		defaultMessage: 'Your Graph',
		description: 'Navigation link to the Your Graphs section of the microsite',
	},
	profileLabel: {
		id: 'twg-microsite.navbar.profileLabel',
		defaultMessage: 'Profile',
		description: 'Label and icon label for the Profile menu item in the user dropdown',
	},
	logoutLabel: {
		id: 'twg-microsite.navbar.logoutLabel',
		defaultMessage: 'Logout',
		description: 'Label and icon label for the Logout menu item in the user dropdown',
	},
	logoAlt: {
		id: 'twg-microsite.navbar.logoAlt',
		defaultMessage: 'Teamwork Graph logo',
		description: 'Accessible label for the Teamwork Graph logo',
	},
} as const;

export const messages: typeof intlMessages = defineMessages(intlMessages) satisfies Record<
	string,
	MessageDescriptor
>;
